export const QUERYABLE_CLIENT_STATUSES = ["active", "inactive"] as const

export type QueryableClientStatus = (typeof QUERYABLE_CLIENT_STATUSES)[number]
